import { useEffect, useState } from 'react';
import './Button.css';


function Box(props) {
  
  return (

    <div className='pixel-box' onClick={props.onClick}>
      {props.children}
    </div>

  )
}

export default Box;
